import { Injectable } from '@angular/core';
import { WebEventTrackingService } from 'src/shared/services/web-event-tracking.service';
import { AuditWebEventTrackerModel, AuditTrackingCategory, ClickEventTypeCategory } from 'src/shared/models/audit-tracking.model';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable()
export class TrackingUtil {

	private _auditWebEventTrackerModel: AuditWebEventTrackerModel;
	private _unsubscribe$ = new Subject();

	constructor(private _webEventTrackingService: WebEventTrackingService,
		private _datepipe: DatePipe) {
	}

	async trackUserClick(event: Event | any, clickEventTypeCategory: ClickEventTypeCategory) {
		var element = event.target || event.srcElement || event.currentTarget;
		var idAttribute = element.attributes ? element.attributes.id : '';
		var elementId = idAttribute ? idAttribute.nodeValue : '';
		var description = `'${element.innerText.trim()}' clicked. Click type: ${clickEventTypeCategory}.`;

		this._auditWebEventTrackerModel = new AuditWebEventTrackerModel();
		this._auditWebEventTrackerModel.httpMethod = "HttpPost";
		this._auditWebEventTrackerModel.actionCategory = AuditTrackingCategory.clickTracking;
		this._auditWebEventTrackerModel.eventDateTime = this._datepipe.transform(new Date(), 'yyyy-MM-dd');
		this._auditWebEventTrackerModel.eventType = clickEventTypeCategory;
		this._auditWebEventTrackerModel.eventId = elementId;
		this._auditWebEventTrackerModel.description = description;

		this.callTrackUserAction();
	}

	async trackUserClickWithCustomDescription(event: Event | any, clickEventTypeCategory: ClickEventTypeCategory, description: string) {
		var element = event.target || event.srcElement || event.currentTarget;
		var idAttribute = element.attributes.id;
		var elementId = idAttribute.nodeValue;

		if (!description || description.length === 0) {
			description = `'${element.innerText.trim()}' clicked. Click type: ${clickEventTypeCategory}.`;
		}

		this._auditWebEventTrackerModel = new AuditWebEventTrackerModel();
		this._auditWebEventTrackerModel.httpMethod = "HttpPost";
		this._auditWebEventTrackerModel.actionCategory = AuditTrackingCategory.clickTracking;
		this._auditWebEventTrackerModel.eventDateTime = this._datepipe.transform(new Date(), 'yyyy-MM-dd');
		this._auditWebEventTrackerModel.eventType = clickEventTypeCategory;
		this._auditWebEventTrackerModel.eventId = elementId;
		this._auditWebEventTrackerModel.description = description;

		this.callTrackUserAction();
	}

	private callTrackUserAction() {
		this._webEventTrackingService.trackUserAction(this._auditWebEventTrackerModel);
	}
}
